<div class="dsm-flex-container page-not-found">
    <div class="panel">
        <div class="card">
            <div class="card-content">
                <h1 class="heading-2" translate="cart.marketing.pages.not.found.title"></h1>
                <p translate="cart.marketing.pages.not.found.message"></p>
                <button type="button" class="button button-large button-primary"
                        translate="cart.marketing.pages.not.found.button" [routerLink]="LANDING_ROUTE"></button>
            </div>
            <img class="bottom-right-wave" aria-hidden="true" src="/image-service/ws/imgs/file/4992766/aws/w/0/h/0.img" alt="">
            <img class="top-left-wave" aria-hidden="true" src="/image-service/ws/imgs/file/4992767/aws/w/0/h/0.img" alt="">
        </div>
    </div>
</div>
